import { assertDomainShape } from '../schemaAssert.js';
import { buildDomainCapabilities, buildDomainSurfaces } from '../centralModel.js';

export const INCIDENT_REPORTS_DOMAIN_ID = 'incident-reports';

const PRIMARY = {
  id: 'reportType',
  label: 'Report type',
  type: 'multiChoice',
  options: [
    { value: 'behaviour', label: 'Behaviour', color: 'error' },
    { value: 'safety', label: 'Safety', color: 'warning' },
    { value: 'bullying', label: 'Bullying', color: 'error' },
    { value: 'property', label: 'Property', color: 'info' },
    { value: 'other', label: 'Other', color: 'neutral' },
  ],
};

const FOLLOW_UP = [
  { id: 'title', label: 'Title', type: 'string', optional: false },
  { id: 'description', label: 'Description', type: 'text', optional: false },
  { id: 'incidentLocation', label: 'Location', type: 'string', optional: true },
  {
    id: 'severity',
    label: 'Severity',
    type: 'multiChoice',
    optional: false,
    options: [
      { value: 'low', label: 'Low' },
      { value: 'medium', label: 'Medium' },
      { value: 'high', label: 'High' },
      { value: 'critical', label: 'Critical' },
    ],
  },
  {
    id: 'participantRole',
    label: 'Role for selected learner(s)',
    type: 'multiChoice',
    optional: false,
    options: [
      { value: 'involved', label: 'Involved' },
      { value: 'affected', label: 'Affected' },
      { value: 'witness', label: 'Witness' },
      { value: 'accused', label: 'Accused' },
    ],
  },
  { id: 'statement', label: 'Initial statement', type: 'text', optional: true },
];

export const incidentReportsDomainConfig = assertDomainShape({
  id: INCIDENT_REPORTS_DOMAIN_ID,
  name: INCIDENT_REPORTS_DOMAIN_ID,
  label: 'Incident Reports',
  description: 'Sealed incident reports and administrative case review.',
  protected: false,
  active: true,
  parentDomainId: 'discipline',
  sortOrder: 110,
  icon: null,
  color: 'warning',
  defaultInputMethod: 'individual',
  defaultView: 'search',
  collections: {
    events: 'studentProfileItems',
    rules: 'incidentReportRules',
    types: 'incidentReportTypes',
    actions: 'incidentReportActions',
    queue: 'incidents',
  },
  eventsCollection: 'studentProfileItems',
  rulesCollection: 'incidentReportRules',
  capabilities: buildDomainCapabilities({
    collective: {
      enabled: true,
      aggregates: ['count', 'breakdown', 'trend', 'baseline'],
      audiences: ['staff'],
      sensitivity: 'restricted',
    },
    actions: { enabled: true, outcomes: ['case-follow-up'] },
  }),
  surfaces: buildDomainSurfaces({ rules: false, dashboard: true, reports: true }),
  primary: PRIMARY,
  followUp: FOLLOW_UP,
  terminology: {
    event: { label: 'incident report', plural: 'incident reports', description: 'Full staff incident report' },
    category: { label: 'report type', plural: 'report types', description: '' },
    type: { label: 'report type', plural: 'report types', description: '' },
    action: { label: 'follow-up', plural: 'follow-ups', description: '' },
    rule: { label: 'rule', plural: 'rules', description: '' },
    queue: { label: 'incident queue', plural: 'incident queues', description: '' },
  },
  contextTags: {},
  scope: { grades: [] },
});

export default incidentReportsDomainConfig;
